import React = require('react');

export const ContactUs = () => {
  return (
    <div className="call-center">
      <h3 className="title">WHOOPS!</h3>
      <p>Unfortunately, we have been unable to make the change you have requested.</p>
      <p>Please contact us in order to make the change and keep your policy up to date. Details on how to contact us
        can be found
        <a target={'_blank'} href={'https://www.admiral.com/contact-us/travel'}> here </a>
      </p>
      <p>It is important that your details are kept up to date, as incorrect information could invalidate your cover
        or affect any future claims.</p>
    </div>
  )
}
